import * as Yup from 'yup';
import { DictionaryIndicator } from '../../models';

export function useValidationSchema() {
  return Yup.object<DictionaryIndicator>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    code: Yup.string().nullable().required('Povinné pole'),
  });
}
